class GiftCardBalanceForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.output = this.querySelector('output');

    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    event.preventDefault();

    const formData = new FormData(this.form);
    const email = formData.get('email');
    const code = formData.get('code');

    const response = await fetch(
      'https://us-central1-maiden-home-prod.cloudfunctions.net/api/gift-card/check-balance',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, code }),
      }
    );

    if (response.status !== 200) {
      this.showError();
      return;
    } else {
      const data = await response.json();

      const card = data.cards.find((card) => card.last_characters === code);

      if (!card) {
        this.showError();
        return;
      }

      this.output.classList.add('success');
      this.output.classList.remove('error');
      this.output.querySelector('.balance__amount').textContent = card.balance;
      this.output.querySelector('.not-found').textContent = '';
      try {
      } catch (e) {
        this.showError();
        return;
      }
    }
  }

  showError() {
    this.output.classList.add('error');
    this.output.classList.remove('success');
    this.output.querySelector('.balance__amount').textContent = '';
  }
}

customElements.define('gift-card-balance-form', GiftCardBalanceForm);
